var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._l((_vm.links),function(item,index){return [(item.access)?_c(_vm.resolveNavItemComponent(item),{key:index,tag:"component",attrs:{"item":item}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }